module.exports = __webpack_public_path__ + "img/healthPro1.efd75293.png";